module.exports = __webpack_public_path__ + "img/moishop_portfolio_6_mob_2x.7f9e7b2f.png";